export const EVAL_ANS_SUBMIT_REQUEST = 'EVAL_ANS_SUBMIT_REQUEST';
export const EVAL_ANS_SUBMIT_SUCCESS = 'EVAL_ANS_SUBMIT_SUCCESS';
export const EVAL_ANS_SUBMIT_FAIL = 'EVAL_ANS_SUBMIT_FAIL';
export const EVAL_ANS_SUBMIT_RESET = 'EVAL_ANS_SUBMIT_RESET';
